import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { getTokenHeader } from "@/helpers/commonHelper";
import { getGlobalFeatureGroups } from "@/helpers/featureGroupHelper.js";
import EventFeatureConfig from "@/components/Events/EventFeatureConfig/EventFeatureConfig.vue";
export default {
  name: "EventAdminFeatures",
  data: () => ({
    showFeatureInput: false,
    snackbarText: "",
    snackbarColor: "",
    snackbar: false
  }),
  async mounted() {
    try {
      await this.$store.dispatch("getFeatureGroupsForEvents", { getAll: true });
    } catch (error) {
      await this.$store.dispatch("createError", error);
    }
  },
  methods: {
    getGlobalFeatureGroups,

    createSuccess(message) {
      this.snackbarText = message;
      this.snackbarColor = "#00636C";
      this.snackbar = true;
    },
    async updateGroup(args) {
      let { group, successText } = args;
      if (group.title) {
        const headers = getTokenHeader();
        try {
          const res = await axios.put(
            `${env.events_api_client_url}feature_group`,
            group,
            { headers, params: { principal_id: this.selectedPrincipal.id } }
          );
          if (res.status === 200) {
            await this.$store.dispatch("createSuccess", successText);
            this.selectedGroup = {};
            group = {};
          }
        } catch (error) {
          await this.$store.dispatch("createError", error);
        }
      }
    },

    async createGroup(args) {
      let { global, createInputValue } = args;
      if (createInputValue) {
        const headers = getTokenHeader(),
          postData = {
            title: createInputValue
          };

        if (!global) postData.owner = this.selectedPrincipal.id;
        if (!global) postData.principals = [this.selectedPrincipal.id];

        try {
          const res = await axios.post(
            `${env.events_api_client_url}feature_group/`,
            postData,
            {
              headers,
              params: {
                principal_id: this.selectedPrincipal.id
              }
            }
          );
          if (res.status === 200 || res.status === 201) {
            await this.$store.dispatch(
              "createSuccess",
              "Gruppe wurde erfolgreich erstellt"
            );
            createInputValue = "";
            this.createInputValid = true;
            await this.$store.dispatch("getFeatureGroupsForEvents", {
              getAll: true
            });
          } else
            await this.$store.dispatch("createError", {
              text: "Fehler beim Anlegen!",
              status: res.status
            });
        } catch (error) {
          await this.$store.dispatch("createError", error);
        }
      }
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isEventAdmin() {
      return this.currentUser?.scopes?.includes("role:events_admin");
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    featureGroups() {
      return this.$store.state.featureGroupsForEvents;
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    ownFeatureGroups() {
      return (
        this.featureGroups.filter(
          featureGroup => featureGroup.owner === this.selectedPrincipal.id
        ) || []
      );
    },
    globalFeatureGroups() {
      return this.getGlobalFeatureGroups(null);
    },
    selectedFeatureGroups: {
      get() {
        return this.getGlobalFeatureGroups(true);
      },
      async set(newVal) {
        const oldVal = this.selectedFeatureGroups,
          changedValues = [],
          globalGroups = this.getGlobalFeatureGroups(null);

        if (newVal.length > oldVal.length)
          newVal.forEach(val => {
            if (!oldVal.find(ov => ov._id === val)) {
              const changedVal = globalGroups?.find(group => group._id === val);
              changedVal.principals.push(this.selectedPrincipal.id);
              changedValues.push(changedVal);
            }
          });
        else
          oldVal.forEach(val => {
            if (!newVal.find(nv => nv === val._id)) {
              val.principals.remove(this.selectedPrincipal.id);
              changedValues.push(val);
            }
          });

        await changedValues.asyncForEach(async val => {
          await this.updateGroup({
            group: val,
            successText: "Erfolgreich gespeichert"
          });
        });
      }
    }
  },
  components: { EventFeatureConfig }
};
